import { render, staticRenderFns } from "./FAservices.vue?vue&type=template&id=38440878&scoped=true&"
import script from "./FAservices.vue?vue&type=script&lang=js&"
export * from "./FAservices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38440878",
  null
  
)

export default component.exports